import { render, staticRenderFns } from "./commonTable.vue?vue&type=template&id=149e56dd"
import script from "./commonTable.vue?vue&type=script&lang=js"
export * from "./commonTable.vue?vue&type=script&lang=js"
import style0 from "./commonTable.vue?vue&type=style&index=0&id=149e56dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports